import React from "react";
import { Avatar, Heading, Text, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import myPhoto from "../images/myPhoto.jpg";

const greeting = "Hello, I am Sneha!";
const bio1 = "A frontend developer";
const bio2 = "specialised in React";

const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#2A4365"
  >
    <VStack spacing={6} alignItems="center">
      {/* Avatar */}
      <Avatar
        src={myPhoto}
        size="2xl"
      />

      {/* Greeting */}
      <Text fontSize="lg" color="white">
        {greeting}
      </Text>

      {/* Bio */}
      <Heading
        as="h1"
        size="2xl"
        color="white"
        textAlign="center"
      >
        {bio1}
        <br />
        {bio2}
      </Heading>
    </VStack>
  </FullScreenSection>
);

export default LandingSection;